import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import HealthBar from './HealthBar.vue';
import { abbreviateNumber, decimalFormatter } from '@/utils/number';
import { useI18n } from '@/composables/i18n';
import { TranslateResult } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'HealthIndicator',
  props: {
    title: null,
    kpis: null,
    levelMaximums: null,
    value: null,
    decimals: { type: Boolean },
    unit: null
  },
  setup(__props: any) {

const props = __props as {
  title: string | TranslateResult;
  kpis: Record<string, number>;
  levelMaximums: number[];
  value: number;
  decimals: boolean;
  unit?: string;
};



const { t } = useI18n();

function getKpiKey(index: number): string {
  return kpiEntries.value[index][0];
}

function getKpiValue(index: number): number {
  return kpiEntries.value[index][1];
}

const kpiEntries = computed<Array<[string, number]>>(() =>
  Object.entries(props.kpis).map(([key, value]) => [key, value]),
);

const noData = computed<boolean>(
  () => props.levelMaximums.every((x) => x === 0) && props.value === 0,
);

return { __sfc: true,props, t, getKpiKey, getKpiValue, kpiEntries, noData, HealthBar, abbreviateNumber, decimalFormatter }
}

})